import noop from '../../utils/noop';

export default function init(brazeKey, url, callback = noop, options = {}) {
  const { enableHtmlInAppMessagesInBrazeSdkConfig } = options;
  const brazeSdkConfig = {
    baseUrl: url,
    minimumIntervalBetweenTriggerActionsInSeconds: 0,
    enableHtmlInAppMessages: !!enableHtmlInAppMessagesInBrazeSdkConfig,
  };

  const scriptUrl = 'https://js.appboycdn.com/web-sdk/4.10/braze.min.js';

  if (!brazeKey) {
    return;
  }

  (function (a, p, P, b, y) {
    a.braze = {};
    a.brazeQueue = [];
    for (
      var s = 'BrazeSdkMetadata DeviceProperties Card Card.prototype.dismissCard Card.prototype.removeAllSubscriptions Card.prototype.removeSubscription Card.prototype.subscribeToClickedEvent Card.prototype.subscribeToDismissedEvent Card.fromContentCardsJson Banner ImageOnly CaptionedImage ClassicCard ControlCard ContentCards ContentCards.prototype.getUnviewedCardCount Feed Feed.prototype.getUnreadCardCount ControlMessage InAppMessage InAppMessage.SlideFrom InAppMessage.ClickAction InAppMessage.DismissType InAppMessage.OpenTarget InAppMessage.ImageStyle InAppMessage.Orientation InAppMessage.TextAlignment InAppMessage.CropType InAppMessage.prototype.closeMessage InAppMessage.prototype.removeAllSubscriptions InAppMessage.prototype.removeSubscription InAppMessage.prototype.subscribeToClickedEvent InAppMessage.prototype.subscribeToDismissedEvent InAppMessage.fromJson FullScreenMessage ModalMessage HtmlMessage SlideUpMessage User User.Genders User.NotificationSubscriptionTypes User.prototype.addAlias User.prototype.addToCustomAttributeArray User.prototype.addToSubscriptionGroup User.prototype.getUserId User.prototype.getUserId User.prototype.incrementCustomUserAttribute User.prototype.removeFromCustomAttributeArray User.prototype.removeFromSubscriptionGroup User.prototype.setCountry User.prototype.setCustomLocationAttribute User.prototype.setCustomUserAttribute User.prototype.setDateOfBirth User.prototype.setEmail User.prototype.setEmailNotificationSubscriptionType User.prototype.setFirstName User.prototype.setGender User.prototype.setHomeCity User.prototype.setLanguage User.prototype.setLastKnownLocation User.prototype.setLastName User.prototype.setPhoneNumber User.prototype.setPushNotificationSubscriptionType InAppMessageButton InAppMessageButton.prototype.removeAllSubscriptions InAppMessageButton.prototype.removeSubscription InAppMessageButton.prototype.subscribeToClickedEvent FeatureFlag FeatureFlag.prototype.getStringProperty FeatureFlag.prototype.getNumberProperty FeatureFlag.prototype.getBooleanProperty automaticallyShowInAppMessages destroyFeed hideContentCards showContentCards showFeed showInAppMessage deferInAppMessage toggleContentCards toggleFeed changeUser destroy getDeviceId getDeviceId initialize isPushBlocked isPushPermissionGranted isPushSupported logCardClick logCardDismissal logCardImpressions logContentCardImpressions logContentCardClick logContentCardsDisplayed logCustomEvent logFeedDisplayed logInAppMessageButtonClick logInAppMessageClick logInAppMessageHtmlClick logInAppMessageImpression logPurchase openSession requestPushPermission removeAllSubscriptions removeSubscription requestContentCardsRefresh requestFeedRefresh refreshFeatureFlags requestImmediateDataFlush enableSDK isDisabled setLogger setSdkAuthenticationSignature addSdkMetadata disableSDK subscribeToContentCardsUpdates subscribeToFeedUpdates subscribeToInAppMessage subscribeToSdkAuthenticationFailures toggleLogging unregisterPush wipeData handleBrazeAction subscribeToFeatureFlagsUpdates getAllFeatureFlags logFeatureFlagImpression'.split(
          ' '
        ),
        i = 0;
      i < s.length;
      i++
    ) {
      for (var m = s[i], k = a.braze, l = m.split('.'), j = 0; j < l.length - 1; j++) {
        k = k[l[j]];
      }
      // eslint-disable-next-line no-new-func
      k[l[j]] = new Function(
        'return function ' +
          m.replace(/\./g, '_') +
          '(){window.brazeQueue.push(arguments); return true}'
      )();
      /* eslint-enable */
    }
    window.braze.getDeferredInAppMessage = function () {
      return new window.braze.InAppMessage();
    };
    window.braze.getCachedContentCards = function () {
      return new window.braze.ContentCards();
    };
    window.braze.getCachedFeed = function () {
      return new window.braze.Feed();
    };
    window.braze.getUser = function () {
      return new window.braze.User();
    };
    window.braze.getFeatureFlag = function () {
      return new window.braze.FeatureFlag();
    };
    (y = p.createElement(P)).type = 'text/javascript';
    // prevents One Trust from blocking the script
    y.setAttribute('data-ot-ignore', '');
    y.src = scriptUrl;
    y.async = 1;

    a.rbiBrazeInit = () => {
      // Call this function again to get the success value that it return
      a.rbiBraze = a.braze;
      const success = a.rbiBraze.initialize(brazeKey, brazeSdkConfig);

      if (success) {
        a.rbiBraze.automaticallyShowInAppMessages();
        a.rbiBraze.openSession();

        callback();
      }
    };

    y.onload = a.rbiBrazeInit;

    b = p.getElementsByTagName(P)[0];
    b.parentNode.insertBefore(y, b);
  })(window, document, 'script');
}
